define('modules/page_listing/views/add_tag_popup',['require','exports','module','env','common/views/modal_layout','./search_list','./search_tagcloud','lib/util','../models/tag','../collections/tags','../controllers/search','ldsh!../templates/add_tag_popup'],function (require, exports, module) {
  'use strict';

  var Config = require('env'),
    ModalLayout = require('common/views/modal_layout'),
    SearchListView = require('./search_list'),
    SearchCloudView = require('./search_tagcloud'),
    util = require('lib/util'),
    Tag = require('../models/tag'),
    TagCollection = require('../collections/tags');

  var SearchController = require('../controllers/search');

  module.exports = ModalLayout.extend({
    template: require('ldsh!../templates/add_tag_popup'),
    regions: {
      taglist: '.js-tag-list',
      tagcloud: '.js-tag-cloud',
    },
    triggers: {
      'click .js-cancel': 'cancel',
    },
    events: {
      'click .js-create': 'createTags',
      'submit form': 'onSubmit',
      'keydown input': 'onKeyDown',
      'keyup input': 'onKeyUp',
    },
    initialize: function (options) {
      options = options || {};
      this.removeTagOnDelete = !!options.removeTagOnDelete;

      var listView = new SearchListView();
      this.listenTo(listView, 'tag:select', this.addTagToCloud);

      this.collection = new TagCollection();
      this.collection.fetch({
        success: _.bind(function () {
          this.$taglist.show(listView);
          this.$tagcloud.show(
            new SearchCloudView({
              className: 'ed-tag-list',
              collection: this.model.tags.clone(),
              buttonHidden: true,
            })
          );
        }, this),
      });

      this.searchText = '';
    },
    onSubmit: function (e) {
      e.preventDefault();
      if (this.$taglist.currentView.hasTagSelected()) return;
      var selector = 'input',
        text = this.$(selector).val().trim(),
        tagModel = new Tag({ text: text });
      if (text && !this.collection.searchTag(text)) {
        this.addTagToCloud(tagModel);
      }
    },
    createTags: function () {
      var tags = this.$tagcloud.currentView.collection.toJSON();
      this.model.save(
        { tags: tags },
        {
          patch: true,
          success: _.bind(this.trigger, this, 'ok'),
        }
      );
    },
    onRender: function () {
      this.$('input').focus().val(this.searchText);
      this.toggleTagList(this.searchText.length < this.minSearchLength);
      this.$el.i18n();
    },
  });

  util.mixin(module.exports, SearchController);

  _.extend(module.exports, {
    show: function (page) {
      var popup = new module.exports({ model: page }),
        defer = $.Deferred();
      popup.on('ok', _.bind(defer.resolve, defer));
      popup.on('cancel', _.bind(defer.reject, defer));
      defer.always(_.bind(popup.hide, popup));
      return defer.promise();
    },
  });
});

